import { CSSResultGroup, TemplateResult, html, nothing } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { OutlineElement } from '../../base/outline-element/outline-element';

import componentStyles from './sic-carousel-block.css.lit';
import defaultVars from './css-variables/sic-carousel-block-vars.css.lit';

import { SlotsNGController as SlotController } from '../../controllers/slots-ng-controller';

/**
 * The carousel block component
 *
 * @element sic-carousel-block
 * @slot title
 * @slot description
 * @slot cta
 * @slot carousel
 */
@customElement('sic-carousel-block')
export class SicCarouselBlock extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles, defaultVars];
  slots = new SlotController(this);

  @state() hasDescriptionSlot: boolean;
  @state() hasCtaSlot: boolean;

  firstUpdated() {
    this.hasDescriptionSlot =
      this.querySelector(':scope > [slot="description"]') !== null;
    this.hasCtaSlot = this.querySelector(':scope > [slot="cta"]') !== null;
  }

  render(): TemplateResult {
    return html`
      <div class="carousel-block">
        <div class="intro">
          ${this.slots.conditionalSlot('title', false)}
          ${this.hasDescriptionSlot
            ? this.slots.conditionalSlot('description', false)
            : nothing}
          ${this.hasCtaSlot
            ? this.slots.conditionalSlot('cta', false)
            : nothing}
        </div>

        ${this.slots.conditionalSlot('carousel', false)}
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'sic-carousel-block': SicCarouselBlock;
  }
}
